import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const handlingTypesAdapter = getAdapter({ idFieldName: 'value' });

const handlingTypesSlice = createSlice({
  name: 'handlingTypes',
  initialState: handlingTypesAdapter.getInitialState(),
  reducers: {
    setHandlingTypes: (state, { payload: { handlingTypes } }) => {
      handlingTypesAdapter.setAll(state, handlingTypes);
    },
  },
});

const selectors = handlingTypesAdapter.getSelectors(({ handlingTypes }) => handlingTypes);

export const getHandlingTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getHandlingTypes = (state) => getHandlingTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setHandlingTypes,
} = handlingTypesSlice.actions;

export default handlingTypesSlice.reducer;
